import {
	defaultPerfCaptureConfig,
	enabledModulesForPerfCapture,
	type AppPerfCaptureConfig,
} from './constants';

const disabledPerfCaptureConfig: AppPerfCaptureConfig = {
	enabled: false,
	sampleRate: 0.0,
};

export const getAppPerfCaptureConfig = ({ module }: { module: string }): AppPerfCaptureConfig => {
	const isModuleEnabled = enabledModulesForPerfCapture.indexOf(module) > -1;

	// Space to apply gates and experiments.

	return isModuleEnabled ? defaultPerfCaptureConfig : disabledPerfCaptureConfig;
};
